<template>
  <b-modal
    size="lg"
    ref="modal"
    :title="title"
    header-class="border-bottom-0"
    footer-class="border-top-0"
    hide-footer
    no-close-on-backdrop
  >
    <pdv-order-bill-form
      ref="pdvOrderBillForm"
      v-if="step == 1"
      @store="$emit('store')"
    />
    <pdv-success @newOrder="$refs.modal.hide()" v-if="step == 2" />
  </b-modal>
</template>

<script>
import pdvOrderBillForm from "@/components/pdv/sections/PdvOrderBillForm";
import pdvSuccess from "@/components/pdv/sections/PdvSuccess";

export default {
  components: { pdvOrderBillForm, pdvSuccess },

  data: () => ({
    step: 1,
    title: ""
  }),

  mounted() {
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      this.$nextTick(() => {
        try {
          this.$refs.pdvOrderBillForm.focus();
        } catch (e) {}
      });
    });
  },

  methods: {
    open() {
      this.reset();
      this.$refs.modal.show();
      this.title = "Pagamento";
    },

    reset() {
      this.step = 1;
      this.title = "";
    },

    success() {
      this.step = 2;
      this.title = "";
    }
  }
};
</script>

<style></style>
